import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FaBars } from 'react-icons/fa';

// Define props for Header component
interface HeaderProps {
  onMenuToggle: () => void; // Function to call when menu button is clicked
}

const HeaderContainer = styled.header`
  /* Default styles (Desktop) */
  max-width: 1300px; 
  padding: 20px 15px 30px; 
  margin: 0 auto; /* Center the container */
  background-color: #fff;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: right;

  @media (max-width: 768px) { /* Mobile styles */
    justify-content: space-between; /* Space out hamburger and branding */
    padding: 15px 15px 20px; /* Adjust mobile padding if needed */
  }
`;

// Style for the mobile menu button
const MenuButton = styled.button`
  background: none;
  border: none;
  color: #333;
  font-size: 1.3rem;
  cursor: pointer;
  padding: 5px;
  display: none;

  @media (max-width: 768px) {
    display: block;
  }
`;

const HeaderLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  
  &:hover {
    color: inherit;
  }
`;

const Title = styled.h1`
  font-size: 1.8rem;
  font-weight: normal;
  margin: 0;
  color: #333;
  font-family: 'Lucida Bright', 'Lucida Serif', Georgia, serif;
  letter-spacing: 0.5px;
  line-height: 1;
  text-align: right; /* Keeping user's preference */

  @media (max-width: 768px) {
    font-size: 1.4rem; /* Smaller size on mobile */
  }
`;

const Subtitle = styled.h2`
  font-size: 1.0rem;
  font-weight: normal;
  margin: 0;
  color: #666;
  font-family: 'Lucida Bright', 'Lucida Serif', Georgia, serif;
  letter-spacing: 0.5px;
  text-align: right; /* Keeping user's preference */

  @media (max-width: 768px) {
    font-size: 0.8rem; /* Smaller size on mobile */
  }
`;

const HeaderBranding = styled.div`
  /* Container for title/subtitle if needed for layout */
`;

// Accept props in the component definition
const Header: React.FC<HeaderProps> = ({ onMenuToggle }) => {
  return (
    <HeaderContainer>
      {/* Hamburger Menu Button (visible on mobile) */}
      <MenuButton onClick={onMenuToggle} aria-label="Toggle menu">
        <FaBars />
      </MenuButton>
      
      {/* Branding link */}
      <HeaderLink to="/">
        <HeaderBranding> 
          <Title>rory wainwright johnston</Title>
          <Subtitle>conductor · composer</Subtitle>
        </HeaderBranding>
      </HeaderLink>
      
      {/* Removed optional spacer */}
    </HeaderContainer>
  );
};

export default Header; 